module.exports = __webpack_public_path__ + "static/media/gift5.7b0bb22c.jpg";